import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { PersonaleApi } from "../data/apis";
import { useMemo } from "react";

export function usePersonaleCommessaDataSource(idCommessa: number | undefined) {
    const apiConfig = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new PersonaleApi(apiConfig);

        return new CustomStore({
            key: "idPersonale",
            loadMode: 'raw',
            load: (loadOptions) => {
                if (idCommessa) {
                    return api.getPersonaleByIdCommessa({
                        idCommessa: idCommessa
                    });
                } else 
                    return [];
            }
        })
    }, [idCommessa]);

    return dataSource;
}